import {
	Card,
	CardBody,
	Input,
	Table,
	TableCell,
	TableContainer,
	TableHeader,
} from '@windmill/react-ui';
import SubusersTable from 'components/subusers/SubusersTable';
import DataWrapper from './DataWrapper';
import PageTitle from 'components/Typography/PageTitle';
import useAsync from 'hooks/useAsync';
import useFilter from 'hooks/useFilter';
import { useState, useEffect, useContext } from 'react';
import SubusersServices from 'services/SubusersServices';
import sidebar from 'routes/sidebar';
import NotFound from 'components/table/NotFound';
import { FiRefreshCcw } from 'react-icons/fi';
import { SidebarContext } from 'context/SidebarContext';

const Subusers = () => {
	const adminInfo = localStorage.getItem('adminInfo')
		? JSON.parse(localStorage.getItem('adminInfo'))
		: null;
	const { data, loading, error } = useAsync(SubusersServices.getAllSubusers);
	const [itemsPerPage, setItemsPerPage] = useState(10);
	const [status, setStatus] = useState('');
	// const hideView = adminInfo?.permission?.some(
	//   (perm) => perm.id_tab === "subusers" && perm.view === 1
	// );
	const isAdmin = adminInfo?.id === 1;

	const hideView = isAdmin
		? true
		: adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'subusers' && perm.view === 1
		  );

	const [subusersData, setSubusersData] = useState([]);
	const { setIsUpdate } = useContext(SidebarContext);
	const {
		subusersRef,

		dataTable,
		serviceData,
		handleSubmitSubusers,
		currentPage,
	} = useFilter(subusersData, itemsPerPage);
	useEffect(() => {
		if (serviceData.length !== 0) {
			setItemsPerPage(serviceData.length);
		}
	}, [serviceData]);
	useEffect(() => {
		if (data) {
			setStatus(data?.status);
			const responseData = data?.data || [];
			if (Array.isArray(responseData)) {
				const updatedData = responseData.map(
					({
						id,
						agent_email,
						agent_id,
						agent_reference,
						reference_user,
						username,
						email,
						mobile,
						password,
						is_active,
						is_delete,
						role_id,
						role_name,
						...rest
					}) => ({
						id,
						agent_email,
						agent_id,
						agent_reference,
						reference_user,
						username,
						email,
						mobile,
						password,
						is_active,
						is_delete,
						role_id,
						role_name,
						...rest,
					})
				);
				setSubusersData(updatedData);
			} else {
				console.error('Expected an array but got:', responseData);
			}
		} else {
			console.error('Data is null or undefined');
			setStatus(false);
		}
	}, [data]);

	const handleRefresh = () => {
		setIsUpdate(true);
	};

	return (
		<>
			{hideView && (
				<>
					<PageTitle sidebar={sidebar().sidebar} />

					<Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800 mb-5">
						<CardBody>
							<div
								style={{ width: '600px' }}
								className="flex items-center gap-6"
							>
								<Input
									ref={subusersRef}
									className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
									type="search"
									name="search"
									autoComplete="off"
									placeholder="Quick Search"
									onChange={handleSubmitSubusers}
								/>

								<FiRefreshCcw
									onClick={() => {
										handleRefresh();
									}}
									cursor="pointer"
								/>
							</div>
						</CardBody>
					</Card>

					<DataWrapper loading={loading} error={error} status={status}>
						{serviceData?.length ? (
							<TableContainer
								className="mb-4"
								style={{
									maxHeight: '65vh',
									overflowY: 'scroll',
									scrollbarWidth: 'thin',
								}}
							>
								<Table>
									<TableHeader className="custom-table-header capitalize sticky top-0 z-10">
										<tr>
											<TableCell className="text-center">Sl.No.</TableCell>
											<TableCell className="text-center">
												agent reference
											</TableCell>
											<TableCell className="text-center">
												reference user{' '}
											</TableCell>
											<TableCell className="text-center">username</TableCell>
											<TableCell className="text-center">email</TableCell>
											<TableCell className="text-center">role name</TableCell>
											<TableCell className="text-center">Status</TableCell>
											<TableCell className="text-center">View</TableCell>
										</tr>
									</TableHeader>
									<SubusersTable
										subusers={dataTable}
										perpage={itemsPerPage}
										currentPage={currentPage}
									/>
								</Table>
							</TableContainer>
						) : (
							<NotFound title="There are no Subusers." />
						)}
					</DataWrapper>
				</>
			)}
		</>
	);
};

export default Subusers;
